import customFetch from '../../utils/customFetch'

import { API_ENDPOINT } from '../../config'
import { ContentStateInterface, GISResult } from '../../@types/types'
import { geocodeToApp, reversGeoCodeToApp } from './converters/geocode'
import { addressToGeoApi } from './converters/address'

export const getGeoCode = async (insertionData: ContentStateInterface): GISResult => {
  const address = addressToGeoApi(insertionData)
  const searchParams = new URLSearchParams(address as URLSearchParams)
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  }
  const url = `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/geo/geoCode?${searchParams}`
  const response = await customFetch(url, options)
  return geocodeToApp(await response.json())
}

export const getReverseGeoCode = async (latitude: number, longitude: number): GISResult => {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  }
  const url = `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/reverseGeoCode?latitude=${latitude}&longitude=${longitude}`
  const response = await customFetch(url, options)
  return reversGeoCodeToApp(await response.json())
}
